export default __webpack_public_path__ + "static/media/beterraga.8da144dc.jpeg";